import { ChangeDetectorRef, Component, inject, input, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbProgressbarModule } from '@ng-bootstrap/ng-bootstrap';
import { BackEndService } from 'src/app/services/backend.service';
import { DownloadComponentBase } from 'src/app/shared/components/download-component-base/download-component-base';
import { InputDialogComponent, InputDialogStepComponent, StepState } from 'src/app/shared/components/input-dialog/input-dialog.component';
import { Article } from 'src/app/state';

@Component({
  selector: 'thumbs-comment',
  imports: [
    FormsModule,
    NgbProgressbarModule,
    InputDialogComponent,
    InputDialogStepComponent,
  ],
  templateUrl: './thumbs-comment.component.html',
  styleUrl: './thumbs-comment.component.scss'
})
export class ThumbsCommentComponent extends DownloadComponentBase<Article> {
  @ViewChild('sendFeedbackDialog') sendFeedbackDialogComponent: InputDialogComponent = {} as InputDialogComponent

  historyID = input<number>(0, { alias: 'historyid' }) // The ID of the chat history
  feedbackType = input<string>('negative', { alias: 'feedbacktype' }) // 'positive' or 'negative'

  public feedbackMessage: string = ''
  public dialogTitle = 'Feedback'
  public actionProgress = 100


  private backend = inject(BackEndService)
  private changeDetector = inject(ChangeDetectorRef)

  public handleFeedback() {
      this.dialogTitle = `Please provide your ${this.feedbackType()} feedback`
      this.sendFeedbackDialogComponent.showModal({ historyID: this.historyID(), feedbackType: this.feedbackType() })
      this.changeDetector.detectChanges()
  }


  cancelCurrentAction() {
    this.feedbackMessage = ''
  }

  sendStage(returned: StepState) {
    if (returned.step === 2) {
      const self = this

      this.backend.addChatHistoryFeedback(this.sendFeedbackDialogComponent.state.historyID, this.sendFeedbackDialogComponent.state.feedbackType, this.feedbackMessage)
        .subscribe(
          () => {
            self.sendFeedbackDialogComponent.advanceToNextStep()
            self.cancelCurrentAction()
          }
        )
    }
  }

  checkFeedbackMessage() {
    return true
  }
}
